<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">            
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
		  <el-form-item style="width:8%">
		      <el-select v-model="flowquery.flowtype" filterable remote reserve-keyword @change="changetimetype">
		          <el-option v-for="(item,index) in flowtype" :key="index" :label="item.name" :value="item.id"></el-option>
		      </el-select> 
		  </el-form-item>
		        
		  <!-------按日期查找-------------->
		  <el-form-item style="width:12%" v-if="flowquery.flowtype==3 || flowquery.flowtype==4">
		      <el-date-picker v-model="flowquery.start" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		  </el-form-item>
		  <el-form-item style="width:12%" v-if="flowquery.flowtype==3 || flowquery.flowtype==4">
		      <el-date-picker v-model="flowquery.end" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		  </el-form-item>
		        
		  <!--------按月份查找------------->
		  <el-form-item style="width:12%" v-if="flowquery.flowtype==2">
		      <el-date-picker v-model="flowquery.start" type="month" placeholder="开始月份" format="yyyy-MM" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		  </el-form-item>
		  <el-form-item style="width:12%" v-if="flowquery.flowtype==2">
		      <el-date-picker v-model="flowquery.end" type="month" placeholder="结束月份" format="yyyy-MM" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		  </el-form-item>
		        
		  <!--------按年份查找------------->
		  <el-form-item style="width:12%" v-if="flowquery.flowtype==1">
		      <el-date-picker v-model="flowquery.start" type="year" placeholder="开始年份" format="yyyy" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		  </el-form-item>
		  <el-form-item style="width:12%" v-if="flowquery.flowtype==1">
		      <el-date-picker v-model="flowquery.end" type="year" placeholder="结束年份" format="yyyy" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		  </el-form-item>
		        
		  <el-form-item style="width:15%">
			  <el-select v-model="flowquery.brandid" clearable filterable placeholder="按品牌" clearable @change="flowselect=true">
			      <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
			      	  <span style="float: left">{{item.name}}</span>
      				  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
			      </el-option>
			  </el-select>
		  </el-form-item>
			    
		  <el-form-item style="width:12%">
		      <el-input v-model="flowquery.key" @change="flowselect=true" placeholder="商品名称 / 编号 /条形码" clearable/>
		  </el-form-item>
		        		        
		  <el-form-item>
		  	  <el-button type="primary" icon="el-icon-search" @click="getflowdata">搜索</el-button>
		      <el-button type="primary" @click="outdatas" :loading="outputLoading">导出</el-button>
		  </el-form-item>
	  </el-form>
	  
	  <!--
	  <div class="backborder2" style="background:#fff;margin-top:10px;border-radius:15px;overflow:hidden;padding:20px 1%" v-loading="flowqueryloading">
	  	  <div class="sasinside">
	  	  	  <table class="sastable" border="0" cellspacing="0" cellpadding="0">
			  	  <tr>
			  	  	<th></th>
			  	  	<th colspan="2" align="center">期初库存</th><th colspan="2" align="center">商品进货</th>
			  	  	<th colspan="2" align="center">出库（消费）</th><th colspan="2" align="center">出库（赠送）</th>
			  	  	<th colspan="2" align="center">出库（自用）</th><th colspan="2" align="center">出库（报废）</th>
			  	  	<th colspan="2" align="center">商品退货</th><th colspan="2" align="center">采购退货</th>
			  	  	<th colspan="2" align="center">盘点（盘盈）</th><th colspan="2" align="center">盘点（盘亏）</th>
			  	  	<th colspan="2" align="center">期末库存</th>
			  	  </tr>
			  	  <tr>
			  	  	<th align="center" v-if="searchtype=='time'">时间</th>
					<th align="left" v-if="searchtype=='goods'">商品名称</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  	<th align="center">数量</th><th align="center">金额</th>
			  	  </tr>
			  	  <tr v-for="(item,index) in flowquerylists" :key="index">
			  	    <td align="center" v-if="searchtype=='time'">{{item.date}}</td>
					<td align="left" v-if="searchtype=='goods'">{{item.name}}</td>
			  	  	<td align="center">{{item.allinputnums}}</td>
			  	  	<td align="center">{{item.allinputtotals}}</td>
			  	  	<td align="center">{{item.inputnums}}</td>
			  	  	<td align="center">{{item.inputtotals}}</td>
			  	  	<td align="center">{{item.sellxfnums}}</td>
			  	  	<td align="center">{{item.sellxftotals}}</td>
			  	  	<td align="center">{{item.sellzsnums}}</td>
			  	  	<td align="center">{{item.sellzstotals}}</td>
			  	  	<td align="center">{{item.sellzynums}}</td>
			  	  	<td align="center">{{item.sellzytotals}}</td>
			  	  	<td align="center">{{item.sellbfnums}}</td>
			  	  	<td align="center">{{item.sellbftotals}}</td>
			  	  	<td align="center">{{item.refundnums}}</td>
			  	  	<td align="center">{{item.refundtotals}}</td>
			  	  	<td align="center">{{item.sellcgrefundnums}}</td>
			  	  	<td align="center">{{item.sellcgrefundtotals}}</td>
			  	  	<td align="center">{{item.pdinputnums}}</td>
			  	  	<td align="center">{{item.pdinputtotals}}</td>
			  	  	<td align="center">{{item.pdsellnums}}</td>
			  	  	<td align="center">{{item.pdselltotals}}</td>
			  	  	<td align="center">{{item.endnums}}</td>
			  	  	<td align="center">{{item.endtotals}}</td>
			  	  </tr>
		  	  </table>
	  	  </div>
	  	  <div class="block" style="float:left;width:100%;">
			  <el-pagination
				  @size-change="flowpageSizeChange"
				  @current-change="flowpageCurrentChange"
				  :current-page="flowquery.p"
				  :page-sizes="[10, 20, 50,1000]"
				  :page-size="flowquery.rollpage"
				  layout="total, sizes, prev, pager, next, jumper"
				  :total="flowquery_total_rows">
			  </el-pagination>
		   </div>     		    	
	  </div>
	  -->




	  <div class="backborder2" style="background:#fff;margin-top:10px;border-radius:15px;overflow:hidden;padding:20px 1%" v-loading="flowqueryloading">
	  	  <div class="sasinside">
	  	  	  <table class="sastable" border="0" cellspacing="0" cellpadding="0">
			  	  <tr>
			  	  	<th colspan="2"></th>
			  	  	<th colspan="1" align="center">期初库存信息</th>
					<th colspan="4" align="center">入库信息</th>
					<th colspan="7" align="center">出库信息</th>
					<th colspan="2" align="center">期末库存信息</th>
			  	  </tr>
			  	  <tr>
					<th align="center">时间</th>
					<th align="left">商品信息</th>
					<th align="center" style="background:#E6A23C;color:#fff">期初库存</th>
			  	  	<th align="center" style="background:#E6A23C;color:#fff">总入库信息</th>
					<th align="center">采购入库</th>
					<th align="center">退货入库</th>
					<th align="center">盘盈入库</th>
					<th align="center" style="background:#E6A23C;color:#fff">总出库信息</th>
					<th align="center">消费出库</th>
					<th align="center">赠送出库</th>
					<th align="center">自用出库</th>
					<th align="center">报废出库</th>
					<th align="center">采购退货出库</th>
					<th align="center">盘亏出库</th>
					<th align="center" style="background:#E6A23C;color:#fff">期末库存</th>
			  	  </tr>
				  <tr v-for="(item,index) in flowquerylists" :key="index">
			  	    <td align="center">{{item.days}}</td>
					<td align="left">
						<div>
						   <span style="float:left;width:100%;line-height:25px">{{item.productname}}</span>
						   <span style="float:left;width:100%;color:#999999;font-size:12px;line-height:23px">规格：{{item.productspec}}，编号：{{item.productnumber}}</span>
						   <span style="float:left;width:100%;color:#999999;font-size:12px;line-height:23px">品牌：{{item.brandname}}</span>
						</div>
					</td>
			  	  	<td align="center" style="color:rgb(230, 162, 60);font-weight:bold">
						<div>
						   <span style="float:left;width:100%">{{item.lastbasenums}}</span>
						   <span style="float:left;width:100%">￥{{item.lastbasetotals}}</span>
						</div>	
					</td>
					<td align="center" style="color:rgb(230, 162, 60);font-weight:bold">
						<div>
						   <span style="float:left;width:100%">{{item.allinputnums}}</span>
						   <span style="float:left;width:100%">￥{{item.allinputtotals}}</span>
						</div>	
					</td>
					<td align="center">
						<div>
						   <span style="float:left;width:100%">{{item.inputnums}}</span>
						   <span style="float:left;width:100%">￥{{item.inputtotals}}</span>
						</div>	
					</td>
					<td align="center">
						<div>
						   <span style="float:left;width:100%">{{item.refundnums}}</span>
						   <span style="float:left;width:100%">￥{{item.refundtotals}}</span>
						</div>	
					</td>
					<td align="center">
						<div>
						   <span style="float:left;width:100%">{{item.pdinputnums}}</span>
						   <span style="float:left;width:100%">￥{{item.pdinputtotals}}</span>
						</div>	
					</td>
					<td align="center" style="color:rgb(230, 162, 60);font-weight:bold">
						<div>
						   <span style="float:left;width:100%">{{item.allsellnums}}</span>
						   <span style="float:left;width:100%">￥{{item.allselltotals}}</span>
						</div>	
					</td>
					<td align="center">
						<div>
						   <span style="float:left;width:100%">{{item.sellxfnums}}</span>
						   <span style="float:left;width:100%">￥{{item.sellxftotals}}</span>
						</div>	
					</td>
					<td align="center">
						<div>
						   <span style="float:left;width:100%">{{item.sellzsnums}}</span>
						   <span style="float:left;width:100%">￥{{item.sellzstotals}}</span>
						</div>	
					</td>
					<td align="center">
						<div>
						   <span style="float:left;width:100%">{{item.sellzynums}}</span>
						   <span style="float:left;width:100%">￥{{item.sellzytotals}}</span>
						</div>	
					</td>
					<td align="center">
						<div>
						   <span style="float:left;width:100%">{{item.sellbfnums}}</span>
						   <span style="float:left;width:100%">￥{{item.sellbftotals}}</span>
						</div>	
					</td>
					<td align="center">
						<div>
						   <span style="float:left;width:100%">{{item.sellcgrefundnums}}</span>
						   <span style="float:left;width:100%">￥{{item.sellcgrefundtotals}}</span>
						</div>	
					</td>
					<td align="center">
						<div>
						   <span style="float:left;width:100%">{{item.pdinputtotals}}</span>
						   <span style="float:left;width:100%">￥{{item.pdselltotals}}</span>
						</div>	
					</td>
					<td align="center" style="color:rgb(230, 162, 60);font-weight:bold">
						<div>
						   <span style="float:left;width:100%">{{item.endnums}}</span>
						   <span style="float:left;width:100%">￥{{item.endtotals}}</span>
						</div>	
					</td>
			  	  </tr>
		  	  </table>
	  	  </div>   		    	
		  <div class="block" style="float:left;width:100%;">
			  <el-pagination
				  @size-change="flowpageSizeChange"
				  @current-change="flowpageCurrentChange"
				  :current-page="flowquery.p"
				  :page-sizes="[10, 20, 50,1000]"
				  :page-size="flowquery.rollpage"
				  layout="total, sizes, prev, pager, next, jumper"
				  :total="flowquery_total_rows">
			  </el-pagination>
		   </div>    
	  </div>






	  
	  <el-dialog title="导出进销存信息确认" :visible.sync="outputDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="outdatalists" border v-loading="outputLoading">
		      	  	<el-table-column prop="days" label="时间" width="90" v-if="searchtype=='time'"></el-table-column>
					<el-table-column prop="name" label="商品名称" width="90" v-if="searchtype=='goods'"></el-table-column>
		          	<el-table-column prop="allinputnums" label="期初库存数量"></el-table-column>
		          	<el-table-column prop="allinputtotals" label="期初库存金额"></el-table-column>
		          	<el-table-column prop="inputnums" label="商品进货数量" align="center"></el-table-column>
		          	<el-table-column prop="inputtotals" label="商品进货金额" align="center"></el-table-column>
		          	<el-table-column prop="sellxfnums" label="出库（消费）数量" width="100" align="center"></el-table-column>
		          	<el-table-column prop="sellxftotals" label="出库（消费）金额" width="100" align="center"></el-table-column>
		          	<el-table-column prop="sellzsnums" label="出库（赠送）数量" width="100" align="center"></el-table-column>
		          	<el-table-column prop="sellzstotals" label="出库（赠送）金额" align="center"></el-table-column>
		            <el-table-column prop="sellzynums" label="出库（自用）数量" align="center"></el-table-column>
		          	<el-table-column prop="sellzytotals" label="出库（自用）金额" align="center"></el-table-column>
		          	<el-table-column prop="sellbfnums" label="出库（报废）数量" align="center"></el-table-column>
		          	<el-table-column prop="sellbftotals" label="出库（报废）金额" align="center"></el-table-column>
		          	<el-table-column prop="refundnums" label="商品退货数量" align="center"></el-table-column>	          	  	          	  
		          	<el-table-column prop="refundtotals" label="商品退货金额"></el-table-column>
		          	<el-table-column prop="sellcgrefundnums" label="采购退货数量" align="center"></el-table-column>	          	  	          	  
		          	<el-table-column prop="sellcgrefundtotals" label="商品退货金额"></el-table-column>
		          	<el-table-column prop="pdinputnums" label="盘点（盘盈）数量" align="center"></el-table-column>	          	  	          	  
		          	<el-table-column prop="pdinputtotals" label="盘点（盘盈）金额"></el-table-column>
		          	<el-table-column prop="pdsellnums" label="盘点（盘亏）数量" align="center"></el-table-column>	          	  	          	  
		          	<el-table-column prop="pdselltotals" label="盘点（盘亏）金额"></el-table-column>
		          	<el-table-column prop="endnums" label="期末库存数量" align="center"></el-table-column>	          	  	          	  
		          	<el-table-column prop="endtotals" label="期末库存金额"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="outputDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>
     
  </div>
  </transition>   
</template>

<script>
export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Report/index",
      transitionshow:true,
      flowquery: {
	      act:'getsellandstoragelists',
	      token:this.$cookies.get('token'),
	      start:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1),
	      end:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1),
	      p:1,
	      rollpage:10,
	      flowtype:2,
	      brandid:'',
	      key:'',
	  },
	  flowtype:[{id:2,name:'按月份'},{id:3,name:'按日期'}],
      flowselect:false,
      brandlists:[],
      flowqueryloading:false,
      flowquerylists:[],
      flowquery_total_rows:0,
      outputLoading:false,
      outdatalists:[],
      outputDialog:false,
      flowselect:false,
	  searchtype:'time',
      
    }
  },

  mounted(){
      this.getBrand();
      //this.getflowdata(); //获取进销存信息
  },
  methods:{
  	  changedate() {
		  this.flowquery.start='';
	      this.flowquery.end='';
	      this.flowselect=true;
	  },
	  
	  //获取品牌
      getBrand(){
	      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
	      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	        }else{
	          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	        }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 获取进销存信息 **/
      getflowdata() {
      	  if(this.flowselect==true) {
      	  	  this.flowquery.p=1;
      	  	  this.flowquery.rollpage=10;
      	  }
      	  this.flowqueryloading=true;

	      var resource = this.$resource(this.url);
	      resource.save(this.flowquery).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		          this.flowqueryloading = false;
	          }else{
		          this.flowquerylists=JSON.parse(Base64.decode(res.data.Data));
		          this.flowquery_total_rows=parseInt(res.data.count);
		          this.flowqueryloading = false;
		          if(this.flowselect==true) this.flowselect=false;
	          }
	      }).catch((res) => {
	          this.flowqueryloading = false;
	      });
      },
      flowpageSizeChange(val) {
          this.flowquery.rollpage = val;
          this.getflowdata();
      },
      flowpageCurrentChange(val) {
          this.flowquery.p = val;
          this.getflowdata();
      },
      
      //导出进销存数据
      outdatas() {
      	  this.outputDialog=true;
      	  this.outputLoading=true;
      	  this.flowquery.isexport=1;
		  
		  //按商品搜索展示商品名称信息
		  if(this.flowquery.flowtype==4) this.searchtype='goods';
		  //按时间搜索展示时间信息
		  if(this.flowquery.flowtype!=4) this.searchtype='time';

	      var resource = this.$resource(this.GLOBAL.exportUrl+'Report/index');
	      resource.query(this.flowquery).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		          this.outputLoading = false;
	          }else{
		          this.outdatalists=JSON.parse(Base64.decode(res.data.Data));
		          this.outputLoading = false;
	          }
	      }).catch((res) => {
	          this.outputLoading = false;
	      });
      },
      
      /** 确认导出订单信息 **/
      sureoutput() {
		  require.ensure([], () => {
			  var { export_json_to_excel } = require('../../vendor/Export2Excel');
			  if(this.searchtype=='time') {
				  var tHeader = ['时间','期初库存数量','期初库存金额','商品进货数量','商品进货金额','出库（消费）数量','出库（消费）金额','出库（赠送）数量','出库（赠送）金额','出库（自用）数量','出库（自用）金额','出库（报废）数量','出库（报废）金额','商品退货数量','商品退货金额','采购退货数量','商品退货金额','盘点（盘盈）数量','盘点（盘盈）金额','盘点（盘亏）数量','盘点（盘亏）金额','期末库存数量','期末库存金额'];
			  	  var filterVal = ['days','allinputnums','allinputtotals','inputnums','inputtotals','sellxfnums','sellxftotals','sellzsnums','sellzstotals','sellzynums','sellzytotals','sellbfnums','sellbftotals','refundnums','refundtotals','sellcgrefundnums','sellcgrefundtotals','pdinputnums','pdinputtotals','pdsellnums','pdselltotals','endnums','endtotals'];
			  }else if(this.searchtype=='goods') {
				  var tHeader = ['商品名称','期初库存数量','期初库存金额','商品进货数量','商品进货金额','出库（消费）数量','出库（消费）金额','出库（赠送）数量','出库（赠送）金额','出库（自用）数量','出库（自用）金额','出库（报废）数量','出库（报废）金额','商品退货数量','商品退货金额','采购退货数量','商品退货金额','盘点（盘盈）数量','盘点（盘盈）金额','盘点（盘亏）数量','盘点（盘亏）金额','期末库存数量','期末库存金额'];
			  	  var filterVal = ['name','allinputnums','allinputtotals','inputnums','inputtotals','sellxfnums','sellxftotals','sellzsnums','sellzstotals','sellzynums','sellzytotals','sellbfnums','sellbftotals','refundnums','refundtotals','sellcgrefundnums','sellcgrefundtotals','pdinputnums','pdinputtotals','pdsellnums','pdselltotals','endnums','endtotals'];
			  }
				
			  var list = this.outdatalists;
			  var data = this.formatJson(filterVal, list);
			  export_json_to_excel(tHeader, data, '进销存记录');
			  this.outputDialog=false;
		  })
      },
    
      //导出表格数据
	  formatJson(filterVal, jsonData) {
　　　　	  return jsonData.map(v => filterVal.map(j => v[j]));
　　       },
      
      //切换时间类型
      changetimetype() {
		  if(this.flowquery.flowtype==4) {
			this.flowquery.act='getsellandstoragelistsfromgoods';
		  }else {
			this.flowquery.act="getsellandstoragelists";
		  }

      	  this.flowselect=true;
      	  this.flowquery.start='';
      	  this.flowquery.end='';
      },
	  
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.sasinside {width:100%;padding:1% 0 1% 0;overflow:auto}
.sastable {border-collapse:collapse;}
.sastable th {font-size:13px;font-weight:normal;line-height:23px;padding:5px 20px;color:#909399;border:1px solid #ebeef5;vertical-align:middle;width:auto;white-space:nowrap;}
.sastable td {color:#333336;font-size:13px;line-height:23px;padding:5px 20px;border:1px solid #ebeef5;vertical-align:middle;width:auto;white-space:nowrap;}
</style>


// WEBPACK FOOTER //
// src/components/stat/StatSellandStorage.vue